export default __webpack_public_path__ + "static/media/Coach-Image.c42c6cb4.png";